import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { Button, Icon } from '@components';

type Props = {
  title: string;
  icon: IconDefinition;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const AdminSectionClusterTabButton = ({
  icon,
  title,
  onClick,
}: Props) => {
  return (
    <Button
      theme
      className="flex h-8 items-center gap-1 rounded-[4px] bg-rebecca pl-1.5 pr-3  text-sm capitalize text-white hover:bg-rebecca-dark active:bg-rebecca"
      onClick={onClick}
    >
      <Icon icon={icon} />
      {title}
    </Button>
  );
};
